import { axios } from '@chipinside/fetcher'

import { endpoint } from '#/store/services/endpoints'
import { Sentry } from '#/store/services/Sentry'
import { listeners } from '#/utils/listeners'

// Configuração da instância do Axios com interceptadores
const axiosInstance = axios.create()

// request interceptor to add token to request headers
axiosInstance.interceptors.request.use(
  async config => {
    if (!config.url?.includes('http') || config.url?.includes(import.meta.env.VITE_API_URL)) {
      Sentry.captureInvalidURL(config)

      config.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'app_version': import.meta.env.VITE_VERSION,
        ...config.headers,
      }

      // Repassa o cookie de autenticação para o backend
      config.withCredentials = true
      // URL base
      config.baseURL = import.meta.env.VITE_API_URL
    }
    return config
  },
  error => Promise.reject(error),
)

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    switch (error?.response?.status) {
      case 401: {
        const { url } = error.config
        //Ignore missing farm code 401
        if (!url.startsWith('api/farm/') && !url.endsWith('/cx')) {
          const intended =
            window.location.pathname !== '/logout' && window.location.pathname !== '/'
              ? `?intended=${window.location.href}`
              : ''
          window.location.replace(`${import.meta.env.VITE_AUTH_URL}/login${intended}`)
        }
        break
      }

      case 402:
        if (window.location.pathname !== '/suspended-account')
          window.location.replace('/suspended-account')
        break

      case 503:
        if (window.location.pathname !== '/maintenance') window.location.replace('/maintenance')
        break

      // Send error to sentry and show dialog for user feedback in ErrorBoundary
      case 500: {
        const requestUrl = error?.response?.config?.url

        if ([endpoint.websocket.authorize()].includes(requestUrl)) {
          return
        }

        window.dispatchEvent(
          new CustomEvent(listeners.errorboundary, {
            detail: error?.response?.data?.error ?? error,
          }),
        )

        break
      }

      default:
        return Promise.reject(error?.response)
    }
  },
)
export { axiosInstance }
